<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{this.lastReevaluatedBy}}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
        </ng-template>
    </incident-dialog-content>
    <form [formGroup]="incidentForm" autocomplete="off" *ngIf="showUserInput">
        <h2>Driver License Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Driver License Number" name="driverLicenseNumber" id="driverLicenseNumber" [isRequired]="true"></user-input>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="list" [parent]="this" label="Driver License Jurisdiction" name="driverLicenseJurisdictionId" id="driverLicenseJurisdictionId" [isRequired]="true" [list]="oosDriverLicenceJurisdictions" listValueMember="value" listDisplayMember="text"></user-input>
                </div>
            </div>
        </fieldset>
        <h2>Affidavit Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="list" [parent]="this" label="Jurisdiction" name="jurisdictionId" id="jurisdictionId" [isRequired]="true" [list]="oosJurisdictions" listValueMember="value" listDisplayMember="text" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="text" [parent]="this" label="State Native Code" name="stateNativeCode" id="stateNativeCode" [isRequired]="true" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="date" [parent]="this" label="Conviction Date" name="convictionDate" [isRequired]="true"></user-input>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="text" [parent]="this" label="Complaint Number" name="complaintNumber" [isRequired]="false"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="text" [parent]="this" label="BAC" name="bac" [isRequired]="true" *ngIf="bacRequired"></user-input>
                    <user-input type="text" [parent]="this" label="BAC" name="bac" [isRequired]="false" *ngIf="!bacRequired"></user-input>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <user-input type="list" [parent]="this" label="Accident Indicator" name="accidentTypeId" id="accidentTypeId" [isRequired]="true" [list]="accidentTypes" listValueMember="value" listDisplayMember="text" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Circumstances</label>
                    <user-input type="bool" [parent]="this" label="Violation Occurred in Commercial Vehicle" name="isOperatingCommercialMotorVehicle" id="isOperatingCommercialMotorVehicle" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="Violation Occurred While Transporting Hazardous Materials" name="isHazmat" id="isHazmat" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="Violation Occurred With Drugs Involved" name="isDrugsInvolved" id="isDrugsInvolved" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="CDL Holder" name="cdlHolderIndicator" id="cdlHolderIndicator" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
            </div>
        </fieldset>
    </form>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer *ngIf="!isLoadingIncident" [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>